import React from 'react';
import Navbar from './navbar';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import './App.css';


 
//Component for Editing personal details
export default function EditPerson () {
  
  const API_URL = process.env.REACT_APP_WEB_API_KEY;

  const navigate = useNavigate();
  const location  = useLocation();
  
  const {cusid,cusname,place,custom} = location.state;
  var customer = [custom];
  console.log(custom);
  console.log(customer);

  function updatecustomer(){
      var cusName = document.getElementById("cusName").value;
      var fatName = document.getElementById("fatName").value;
      var gen = document.getElementById("gen").value;
      var addRess = document.getElementById("addRess").value;
      var city = document.getElementById("city").value;              
      var disTrict = document.getElementById("disTrict").value;
      var mNumber = document.getElementById("mNumber").value;
      var office = document.getElementById("office").value;
      var offAdrs = document.getElementById("offAdrs").value;
      var offPhone = document.getElementById("offPhone").value;      
      const data = new FormData();
      data.append("cusName",cusName);
      data.append("fatName",fatName);
      data.append("gen",gen);
      data.append("addRess",addRess);
      data.append("city",city);
      data.append("disTrict",disTrict);
      data.append("mNumber",mNumber);
      data.append("office",office);
      data.append("offAdrs",offAdrs);
      data.append("offPhone",offPhone);

    fetch(API_URL+"api/Customer/UpdateCustomer?cusId="+cusid,{method:"PUT",body:data}).then(res=>res.json())
    .then(()=>{}) ;

    showOKdialog();

     }
     
     function validate(){
      if(document.getElementById('cusName').value ==='' || document.getElementById('fatName').value === ''||
      document.getElementById('addRess').value===''|| document.getElementById('city').value==='' ||
      document.getElementById('disTrict').value===''||document.getElementById('mNumber').value==='')
      {
        alert("Feilds Cannot be empty"); 
      } 
      else
      {
        if((document.getElementById('mNumber').value.length !== 10))
        {
         alert("Mobile number Should be 10 Digit ");
        }
        else
        {
         return true;
        }
      }
 }      

 function showOKdialog()
  {
  const dialog = document.getElementById('myDialog');
  dialog.showModal();
  }

  return ( 
          
      <>
     <div style={{backgroundColor:"blue", color:"white", height:"30px", width:"100%", 
    paddingTop:"10px", top :"0px", position:"relative", 
    fontFamily:"sans-serif",fontSize:"20px"}}> 
            Customers
    </div>
    <Navbar/>

      
    {/*Heading End */}
    {/*Customer Dialogue Start */}
    
    <div style = {{top:"5px", position:"relative",backgroundColor:"lightskyblue",color:"black",  padding:-1, width:"100%"}}>
      <form>
    <fieldset>
      <legend>Personal Info</legend>
      
      {/* <label for = "idNum">Customer ID</label><br /> */}
      {/* <input type = "text" id = "idNum" style = {{height:"30px",width:"100%"}}  ></input><br/> <br/> */}
      
      <label for = "cusName" >Name </label> <br/>
      <input type = "text" id='cusName'  defaultValue ={customer[0].CustomerName} className='inputfield'  ></input><br/> <br/>
      
      <label for = "fatName" > Father Name</label><br/>
      <input type = "text" id = 'fatName' defaultValue={customer[0].FatherName} className='inputfield' ></input><br/> <br/>
     
      <label for = "gen" >Gender </label> <br/>
      <select id = "gen" name='gender' defaultValue={customer[0].Gender} className='inputfield'>
        <option value = "Male">Male</option>
        <option value = "Female">Female</option>
      </select> <br /><br/>
      
      <label for = "addRess" > Address</label><br/>
      <input type = "text" id='addRess' defaultValue={customer[0].Address} className='inputfield' ></input><br/> <br/>
      
      <label for = "city" > City </label> <br/>
      <input type = "text" id='city' defaultValue={customer[0].City} className='inputfield'></input><br/> <br/>
      
      <label for = "disTrict" > District </label><br/>
      <input type = "text" id = 'disTrict'  defaultValue={customer[0].District} className='inputfield' ></input><br/><br/>
      
      <label for = "mNumber" > Mobile No</label><br/>
      <input type = "text" id = 'mNumber'  defaultValue={customer[0].MobileNumber} className='inputfield' ></input><br/> <br/>
      
    </fieldset>
    <fieldset style={{marginBottom:"10%"}}>
      <legend>Office Info</legend>
      <label for ="office">Office</label><br />
      <input type='text' id='office'  defaultValue={customer[0].OfficeName} className='inputfield'></input><br/><br/>
      <label for = "offAdrs" >Office Address</label><br />
      <textarea id="offAdrs" defaultValue={customer[0].OfficeAddress} name='OAddress' rows="5"  style={{width:"100%"}}></textarea><br/>
      <label for = "offPhone">Phone</label><br/>
      <input type = "text" id="offPhone" defaultValue={customer[0].OfficePhone} className='inputfield'></input><br/><br/>
      <div >
     
      <button type = "button" className="actionbuttons"  onClick={()=>{if(validate()){updatecustomer();}}}>Modify</button> 
      <button type = "button" className="actionbuttons" style ={{backgroundColor:"red"}} onClick={()=>{navigate('/actions', {state:{cusid,cusname,place,custom}})}}>Back</button>
      </div>
      </fieldset>
      </form>
    </div>
    <dialog id="myDialog" className="okdialog"><p>Customer Details Changed</p>
            <button className="okdialogbutton" onClick={()=>{navigate('/actions', {state:{cusid,cusname,place,custom}})}}>OK</button>
    </dialog>
    </>
  
    
  ); 
  }
 





